import { render, staticRenderFns } from "./item-result.vue?vue&type=template&id=f00b964a&scoped=true&lang=pug&"
import script from "./item-result.vue?vue&type=script&lang=js&"
export * from "./item-result.vue?vue&type=script&lang=js&"
import style0 from "./item-result.vue?vue&type=style&index=0&id=f00b964a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b964a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCol,VIcon,VImg})
